





























































































import { Component, Vue } from 'vue-property-decorator'
import { Form as ElForm, Input } from 'element-ui'
import { isValidEmail, isValidPassword, isValidPhoneNumber, isValidUsername } from '@/utils/validate'
import md5 from 'js-md5'
import { register } from "@/api/user";
import { USER } from "@/constant/storageConstant";

@Component({
  name: 'Register'
})
export default class extends Vue {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private validateUserName = (rule: any, value: string, callback: Function) => {
    if (!isValidUsername(value)) {
      callback(new Error('请输入正确的用户名'))
    } else {
      callback()
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private validateEmail = (rule: any, value: string, callback: Function) => {
    if (value === '') {
      callback()
    }
    if (!isValidEmail(value)) {
      callback(new Error('请输入正确的邮箱'))
    } else {
      callback()
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private validatePhoneNumber = (rule: any, value: string, callback: Function) => {
    if (value === '') {
      callback()
    }
    if (!isValidPhoneNumber(value)) {
      callback(new Error('请输入正确的手机号'))
    } else {
      callback()
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private validatePassword = (rule: any, value: string, callback: Function) => {
    if (!isValidPassword(value)) {
      callback(new Error('请输入正确的密码,必须包含6位以上，并且含大写字母，小写字母，数字，特殊符号中的三种及以上'))
    } else {
      callback()
    }
  }

  private registerForm = {
    userName: '',
    password: '',
    phoneNumber: '',
    email: ''
  }

  private registerRules = {
    userName: [{ validator: this.validateUserName, trigger: 'blur' }],
    phoneNumber: [{ validator: this.validatePhoneNumber, trigger: 'blur' }],
    email: [{ validator: this.validateEmail, trigger: 'blur' }],
    password: [{ validator: this.validatePassword, trigger: 'blur' }]
  }

  private passwordType = 'password'
  private loading = false

  private showPwd () {
    if (this.passwordType === 'password') {
      this.passwordType = ''
    } else {
      this.passwordType = 'password'
    }
    this.$nextTick(() => {
      (this.$refs.password as Input).focus()
    })
  }

  mounted () {
    // html加载完成后执行。执行顺序：子组件-父组件
    const isLogin = localStorage.getItem(USER) !== null
    if (isLogin) {
      this.$router.push({
        path: '/'
      })
    }

    if (this.registerForm.userName === '') {
      (this.$refs.userName as Input).focus()
    } else if (this.registerForm.password === '') {
      (this.$refs.password as Input).focus()
    }
  }

  private async handleRegister () {
    (this.$refs.registerForm as ElForm).validate(async (valid: boolean) => {
      if (!valid) {
        return false
      }

      this.loading = true
      const registerParam = {
        userName: this.registerForm.userName,
        password: md5(this.registerForm.password),
        phoneNumber: this.registerForm.phoneNumber !== '' ? this.registerForm.phoneNumber : undefined,
        email: this.registerForm.email !== '' ? this.registerForm.email : undefined
      }

      const result = await register(registerParam)
      if (result.status) {
        localStorage.setItem(USER, JSON.stringify(result.data))
        await this.$router.push({
          path: '/'
        })
      } else {
        this.loading = false
      }
    })
  }

  private async handleLogin () {
    await this.$router.push({
      path: '/login'
    })
  }
}
